export { AdsTable } from './ads-table';
export { AdsTableHeader } from './ads-table-header';
export { adsTableColumns } from './ads-table-columns';
export type { TopAdData, AdsTableProps, AdsTableColumnConfig } from './ads-table-types';
